import React, { useState, useEffect } from 'react'
import {
    CardBlog,
    OverContainer,
    OverContainerSection,
    SectionBlog,
    SectionProfile,
    SectionTitle,
    SectionTwo,
} from './styles'
import { MapSecrets } from './mapBlog'
import { PropsSectionTree } from 'types/contenfull'
import { client } from 'src/api/contenfull'
import { CardAuthor } from './cardAuthor'
import { SocialCard } from './socialCards'
import { ContentPagination } from './contentPagination'
import { Subscribe } from './subscribe'
import { useTranslations } from 'src/provider/LocaleProvider'

const PAGE_SIZE = 4

export function RecentBlog() {
    const t = useTranslations()
    const [entries, setEntries] = useState<PropsSectionTree[]>([])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)

    useEffect(() => {
        const fetchEntries = async () => {
            try {
                const response = await client.getEntries({
                    content_type: 'blogs',
                    limit: PAGE_SIZE,
                    skip: (currentPage - 1) * PAGE_SIZE,
                })

                setEntries(response.items as never)
                setTotalPages(Math.ceil(response.total / PAGE_SIZE))
            } catch (error) {
                console.error('Error fetching entries:', error)
            }
        }

        fetchEntries().then((r) => r)
    }, [currentPage])

    const handlePreviousPage = () => {
        setCurrentPage((prevPage: number) => prevPage - 1)
    }

    const handleNextPage = () => {
        setCurrentPage((prevPage: number) => prevPage + 1)
    }

    return (
        <OverContainerSection id={'blog'}>
            <OverContainer
                marginTop={['xlarge', 'xlarge', 'xxmedium', 'xxlarge']}
            >
                <SectionBlog>
                    <SectionTitle
                        variant={'h2'}
                        fontSize={[
                            'medium',
                            'medium',
                            'xxxmedium',
                            'xxxmedium',
                        ]}
                        fontWeight={600}
                    >
                        {t('blog.recentBlog.title')}
                    </SectionTitle>
                    <CardBlog marginTop={'xxxmedium'}>
                        {entries.map(
                            (Blogs: PropsSectionTree, index: number) => (
                                <MapSecrets
                                    key={`navData-${Blogs?.sys?.id} `}
                                    {...Blogs}
                                    index={index}
                                />
                            )
                        )}
                    </CardBlog>
                    <ContentPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePreviousPage={handlePreviousPage}
                        handleNextPage={handleNextPage}
                        setCurrentPage={setCurrentPage}
                    />
                </SectionBlog>
                <SectionProfile marginTop={['xxxmedium', 'xxxmedium', 0, 0]}>
                    <SectionTwo
                        variant={'h2'}
                        fontSize={['medium', 'medium', 'medium', 'medium']}
                        fontWeight={600}
                    >
                        {t('blog.recentBlog.author')}
                    </SectionTwo>

                    <CardAuthor />
                    <SocialCard />
                    <Subscribe />
                </SectionProfile>
            </OverContainer>
        </OverContainerSection>
    )
}
